import { formatUserFacingError } from '@/lib/errors'
import { useCallback, useEffect, useState } from 'react'
import { taxProfileService } from '../services/taxProfile.service'
import type { MemberTaxProfileDocument } from '@/types'

export function useMyTaxProfile(memberId: string | null) {
  const [profile, setProfile] = useState<(MemberTaxProfileDocument & { id: string }) | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    if (!memberId) {
      setProfile(null)
      return
    }
    setLoading(true)
    setError(null)
    try {
      setProfile(await taxProfileService.getMyProfile(memberId))
    } catch (e) {
      setError(formatUserFacingError(e, 'Failed to load tax profile'))
    } finally {
      setLoading(false)
    }
  }, [memberId])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return {
    profile,
    loading,
    error,
    refresh,
    hasTaxIdOnFile: profile?.hasTaxIdOnFile ?? false,
    saveProfile: taxProfileService.saveProfile,
  }
}
